import type { UseBaseQueryOptions } from '@tanstack/react-query'

import type { Webhook } from 'src/types/webhook'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useQuery from 'src/hooks/utils/useQuery'

const useWebhookQuery = (webhookId: string | undefined, options?: UseBaseQueryOptions<Webhook>) => {
  const account = useAccount()

  return useQuery(
    ['getWebhook', webhookId, account.id],
    async ({ signal }) => {
      const response = await api.get(`/webhooks/account/${account.id}/webhooks/${webhookId}`, { signal })
      return response.data as Webhook
    },
    {
      enabled: !!account.id && !!webhookId,
      refetchOnWindowFocus: false,
      ...options
    }
  )
}

export default useWebhookQuery
